<template>
<div>
    <li 
		class="node-tree" 
		:class="[{'Folder': isFolder(node)},{'NotFolder': !isFolder(node)},{'Curent':isOpen||curent_leaf},{'CheckCurentPath':CheckCurentPath() },{'d-none':display_none}, ]"> 
		<span style="cursor: pointer;" @click="OpenFolder(node)">
			<i class="fa" aria-hidden="true" :class="[{'d-none':!isFolder(node)},{'fa-folder-open-o':isOpen},{'fa-folder-o':!isOpen}]"></i>
			<span class="description" :style="curent_style"  v-html="PrintName(node,filter_str)"></span> 
			<span :class="[{'d-none':SubFilterBtnClick==undefined},]"  @click="SubFilterBtnClick(node)"><i class="fa fa-filter" aria-hidden="true"></i></span>
		</span> 
		{{ createNodeCp() }}
        <ul v-if="isFolder(node)"> 
              <re-node-tree
                v-for="child in node.children"
                v-bind:key="child.id"
                :parent="node"
                :node="child" 
                :class="[{'d-none':!isOpen},{'d-block':isOpen}]" 
                :NotFolderClick="NotFolderClick"
                :curentpath="curentpath"
                :CurentDeep="CurentDeep+1"
                :treeIndexFiltered="treeIndexFiltered"
                :treeIndexFilteredStr="treeIndexFilteredStr"
                :filter_str="filter_str"
                :SubFilterBtnClick="SubFilterBtnClick"
				:OverightAllClick="OverightAllClick"
				:keyFilter="keyFilter"
				:AddStyleFilter="AddStyleFilter"
                > </re-node-tree> 
                <div v-if="AddStaff"> 
            	    <div style="color:#01B0E0;" v-for="staff in node.staffs" :key="staff.id"> {{ staff.fio }}</div>
                </div>
        </ul>
    </li>
</div>
</template>

<script>
  export default {
    name: 'ReNodeTree',
    data () {
	return {
	        ver: 1.2,
	        isOpen: false,
	        curent_style:'',
			display_none:false,
			curent_leaf:false,
	}
    },
    components: {

    },
    computed: {

    },
    props: {
		AddStaff:{type:Boolean,default:true},
		node: Object,
		parent: Object,
		NotFolderClick:{ type:Function, },
		curentpath: Array,
		CurentDeep: Number,
		treeIndexFiltered: { type:Array },
		filter_str: { type:String, default:'' },
		treeIndexFilteredStr: { type:String,default:'' },
		SubFilterBtnClick: Function,
		OverightAllClick:Function,
		keyFilter:Object,
		AddStyleFilter:Object,
    },
    watch: {

    },
    created(){ 
//	this.CheckCurentPath(); 
//

    },
    mounted(){
//	this.CheckCurentPath();     
    },
    methods: {
		PrintName(node,ex){
			let name = node.name;
			//console.log(node);
			if(ex != '' && name.toLocaleUpperCase().indexOf(ex.toLocaleUpperCase()) > -1){
				let add_stype = ''; 
				if(this.AddStyleFilter == undefined || node[this.AddStyleFilter.key] == this.AddStyleFilter.val){ 
					add_stype = this.AddStyleFilter.style; //console.log(this.AddStyleFilter); console.log(name + ' '+ add_stype);
				}
				let t = '<span style="'+add_stype+'">'+name.substr(0,name.toLocaleUpperCase().indexOf(ex.toLocaleUpperCase()))+'<span style="color:red;">'+name.substr(name.toLocaleUpperCase().indexOf(ex.toLocaleUpperCase()),ex.length )+'</span>'+name.substr((name.toLocaleUpperCase().indexOf(ex.toLocaleUpperCase())+ex.length) )+'</span>';
				return t;
			}else{ return name; }
		},
		CheckFilter(){ 
			this.$GVO.test = this.treeIndexFiltered;
			if(this.treeIndexFiltered != undefined && (Object.keys(this.treeIndexFiltered).length > 0 || this.filter_str.length)){
				let tmp_flag = true;
				if(this.treeIndexFilteredStr.indexOf(this.node.cp.toLocaleUpperCase()) > -1 ){ //console.log(this.keyFilter);
					//if(this.keyFilter == undefined || this.node[this.keyFilter.key] == this.keyFilter.val){
					tmp_flag = false; this.isOpen=true;
					//}
				}
				this.display_none = tmp_flag;
			}
		},
		createNodeCp(){
			if(this.node.cp == undefined){ this.node.cp = ''; }
			if(this.parent.cp!=undefined){
				if(this.parent.cp.toLocaleUpperCase().split(' => ').slice(-1)[0] != this.node.name.toLocaleUpperCase()){
					this.node.cp = this.parent.cp+' => '+this.node.name;
				}
			}
			this.CheckFilter();	
			return '';
		},
		isFolder(node){ 
			if(typeof node == undefined ){ return false }
			if(typeof node.children == undefined ){ return false }	    
			if(node.children && node.children.length){return true; }else{return false;}
		},
		isFolderOpen(node){
			if(typeof node.isopen == undefined) {return false;}else{
			if(node.isopen){ return true; }else{ return false;}
			}
		},
		OpenFolder(node){ 
			if(this.OverightAllClick!=undefined){ 
				this.OverightAllClick(node); return; 
			}
			if(this.isFolder(node)){
				// console.log(this.isOpen); 
				if(this.isOpen){this.curentpath[this.CurentDeep]=undefined;}
				this.isOpen = !this.isOpen; 
				// console.log(this.isOpen); 
			}else{
				this.$emit('input', this.content)
				this.NotFolderClick(node,this.dopVModelparam);
			}
		},
		CheckCurentPath(){ 
			if(this.node!=undefined && this.curentpath[this.CurentDeep]!=undefined && this.node.name.trim() == this.curentpath[this.CurentDeep].trim()){
				//console.log(this.curentpath,this.CurentDeep);
				this.isOpen=true;
				if(!this.isFolder(this.node)){ this.curent_leaf=true; this.curent_style=' color: #01B0E0; ';}
			}
			return true;
		}
    },
}
</script>
<style >
    .tree-list ul {
		padding-left: 16px;
		margin: 6px 0;
    }
    .Folder > span > .description{
        font-weight: bold;        
    }
    .NotFolder {
		font-weight: normal;
    }
    .NotFolder .Curent{
		color: #ef8157;
    }
</style>
